var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row flexwrap"},[(_vm.bundleCounts.length)?_c('FleetStatus',{attrs:{"title":"Bundles","values":_vm.bundleCounts,"value-key":"count"}}):_vm._e(),_vm._v(" "),_c('FleetStatus',{attrs:{"title":"Resources","values":_vm.resourceCounts,"value-key":"count"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }